<template>
  <div class="column is-12 tab-content tab-winners">
    <div
      v-if="spinner"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div class="columns">
      <div
        class="column is-12 is-flex"
        style="flex-wrap: wrap;"
      >
        <article
          v-for="(player, index) in players"
          class="box media winner-card"
        >
          <modale-image
            :ref="`modal-${index}`"
            style="display: none"
            :image="player.memberphoto"
            @closeModal="closeModal"
          />
          <figure class="media-left">
            <img
              v-if="!player.memberphoto"
              src="images/profile.png"
              alt="Image"
              @click="previewImage(index)"
            >
            <img
              v-if="player.memberphoto"
              :src="player.memberphoto"
              alt="Image"
              @click="previewImage(index)"
            >
          </figure>
          <div class="media-content">
            <div class="content">
              <router-link :to="{path: `/players/${player.ahlid}`}">
                <h6 class="subtitle is-6 mb-0">
                  {{ player.name }}
                  <div class="chip is-pulled-right">
                    <span class="ml-2">{{ player.date }}</span>
                    <i class="material-icons ml-2">grade</i>
                  </div>
                </h6>
              </router-link>
              <div class="is-clearfix" />
              <router-link :to="{name: 'VenueDetails', params: {id: player.venueid}}">
                <span>{{ player.venue }}</span>
              </router-link>
            </div>
            <nav class="level is-mobile mobile-block">
              <div class="level-left">
                <router-link
                  :to="{path: `/players/${player.ahlid}`}"
                  class="btn-icon tooltip"
                  data-tooltip="View Player Page"
                >
                  <i class="material-icons md-1">assignment_ind</i>
                </router-link>
                <a
                  class="btn-icon tooltip"
                  data-tooltip="Add to Friends list"
                  @click="addFriend(player.ahlid)"
                ><i
                  class="material-icons"
                >group_add</i></a>
                <social-sharing
                  url="https://ahlpoker.com"
                  title="AHL POKER"
                  description="I just took down this AHL Poker tournament"
                  quote="I just took down this AHL Poker tournament"
                  hashtags="ahlpoker"
                  inline-template
                >
                  <a
                    class="btn-icon tooltip"
                    data-tooltip="Share to Facebook"
                  >
                    <network network="facebook">
                      <i class="fab fa-fw fa-facebook-square" />
                    </network>
                  </a>
                </social-sharing>
              </div>
            </nav>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import SocialSharing from 'vue-social-sharing'
  import ModaleImage from '../ModalImage.vue'

  export default {
    name: 'RecentPlayers',
    components: {
      SocialSharing,
      ModaleImage
    },
    props: ['user', 'token'],
    data() {
      return {
        players: [],
        spinner: true,
        showPreviewIndex: ''
      }
    },
    created() {
      this.$axios({
        method: 'POST',
        url: 'general/getrecentwinners',
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token || ''
        }
      })
        .then((res) => {
          this.spinner = false
          this.players = res.data
        })
        .catch((error) => {
          this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
        })
    },
    methods: {
      previewImage(index) {
        this.showPreviewIndex = index
        if (this.$refs[`modal-${index}`][0].$el.getAttribute('style') === 'display: none;') {
          this.$refs[`modal-${index}`][0].$el.style.display = 'block'
        } else this.$refs[`modal-${index}`][0].$el.style.display = 'none'
      },
      closeModal() {
        this.$refs[`modal-${this.showPreviewIndex}`][0].$el.style.display = 'none'
        this.showPreviewIndex = ''
      },
      addFriend(id) {
        this.$axios({
          method: 'POST',
          url: `member/addfriend/${this.token}/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: res.data.message
              })
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      }
    }
  }
</script>
